export class Constants {
    static readonly IconBerichtStatusAlles = 'Globe';
    static readonly IconBerichtStatusOnbestelbaar = 'ErrorBadge';
    static readonly IconBerichtStatusInBehandeling = 'ProgressRingDots';
    static readonly IconBerichtStatusNietBezorgd = 'MailUndelivered';
    static readonly IconBerichtStatusBezorgd = 'CheckMark';
    static readonly IconBerichtStatusHandmatigAfgehandeld = 'ReminderPerson';
    static readonly IconBerichtStatusHOnbekend = 'StatusCircleQuestionMark';
}